export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7287.1b7bb2b0.jpg";